import { createFeatureSelector } from '@ngrx/store';
import * as message from './message.actions';
import { MessageActionTypes } from './message.actions';

const initialState: Message = null;

export interface Message {
    text: string;
    hidden: boolean;
}

export function reducer(state = initialState, action: message.MessageActions): Message {
    switch (action.type) {
        case MessageActionTypes.Set:
            return action.payload;
        default:
            return state;
    }
}

export const selectMessage = createFeatureSelector<Message>('message');
